/*URL base para acessar o magic edition */
export const baseUrl = "https://d.gazetadealagoas.com.br/Edicao-digital";
export const baseHub = "https://d.gazetadealagoas.com.br/hub/json"